var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContactSection"},[_c('iframe',{attrs:{"width":"100%","height":"1000px","src":"https://simpark.racecentres.com/hotlapping"}})])
}]

export { render, staticRenderFns }